var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"position-absolute text-center mx-auto my-auto",attrs:{"src":require('~img/sites/region/region-logo.svg'),"alt":"Der Gutschein für deine Region - Einlösbar in deiner Stadt"}})
}
var staticRenderFns = []

export { render, staticRenderFns }